import GlobalModule from './modules/global';
import AccountModule from './modules/account/index';
import UserProfilesModule from './modules/userProfiles/index';

import PurchaseOrdersModule from './modules/purchaseOrders/index';

import WarehouseShipmentsModule from './modules/warehouseShipments/index';
import InventorySnapshotsModule from './modules/inventorySnapshots/index';

import ItemsReportModule from './modules/itemsReport/index';
import BrandsModule from './modules/brands/index';
import ProjectsModule from './modules/projects/index';
import WarehousesModule from './modules/warehouses/index';
import WarehouseTransfersModule from './modules/warehouseTransfers/index';
import ManualShipmentsModule from './modules/manualShipments/index';
import ImportSheetMappingMethodsModule from './modules/importSheetMappingMethods/index';

import StorefrontBulkActionsModule from './modules/storefrontBulkActions/index';
import StorefrontOrdersFulfillmentModule from './modules/storefrontOrdersFulfillment/index';

import GeneratedReportsModule from './modules/generatedReports/index';
import WarehouseProductLocationsModule from './modules/warehouseProductLocations/index';
import BrandItemsModule from './modules/brandItems/index';

import RateCardsModule from './modules/rateCards/index';

import BulkShipmentsModule from './modules/bulkShipments/index';

import LogActionsModule from './modules/logActions/index';
import ShipCodeMappings from './modules/shipCodeMappings/index';
import ProductMappingsModule from './modules/productMappings/index';
import ProductMappingRequestsModule from './modules/productMappingRequests/index';
import ClientShipCodeMappings from './modules/clientShipCodeMappings/index';
import BrandRateShops from './modules/brandRateShops/index';
import IRMSPurchaseOrdersModule from './modules/irmsPurchaseOrders/index';
import IRMSCustomerOrdersModule from './modules/irmsCustomerOrders/index';
import OrdersModule from './modules/orders/index';
import OrderTagsModule from './modules/orderTags/index';
import ReturnsModule from './modules/returns/index';

import TPLFacilitiesModule from './modules/tpl/facilities/index';
import TPLCustomersModule from './modules/tpl/customers/index';
import TPLShipmentServicesModule from './modules/tpl/shipmentServices/index';
import TPLBillingCodesModule from './modules/tpl/billingCodes/index';
import TPLUOMModule from './modules/tpl/uom/index';
import TPLCarriers from './modules/tpl/carriers/index';
import TPLReceivers from './modules/tpl/receivers/index';
import TPLAdjustmentsModule from './modules/tpl/adjustments/index';

import BillingCustomerInvoicesModule from './modules/billing/customerInvoices/index';
import BillingCustomerBillingLedgerModule from './modules/billing/customerBillingLedger/index';
import BillingPtcFilesModule from './modules/billing/ptcFiles/index';
import BillingCarrierInvoicesModule from './modules/billing/carrierInvoices/index';
import CarrierBillingEntriesModule from './modules/billing/carrierBillingEntries/index';
import CarrierInvoiceChargeConfigurationsModule from './modules/billing/carrierInvoiceChargeConfigurations/index';
import ZoneLookupCardItemsModule from './modules/billing/zoneLookupCardItems/index';
import ConversionRateHistoricalRecordsModule from './modules/billing/conversionRateHistoricalRecords/index';

import Automation from './modules/automation/automation/index';
import ContentTemplates from './modules/automation/contentTemplates/index';
import AutomationsContent from './modules/automation/automationsContent/index';

import ManageUsersModule from './modules/manageUsers/index';
import UserInvitesModule from './modules/userInvites/index';

import StorefrontShipmentsModule from './modules/storefrontShipments';
import ShipmentLabelsModule from './modules/shipmentLabels';
import StorefrontProductsModule from './modules/storefrontProducts';

import WorkOrdersModule from './modules/manufacturing/workOrders/index';
import RnDProjectsModule from './modules/manufacturing/rndProjects/index';
import BillOfMaterialsModule from './modules/manufacturing/billOfMaterials/index';

import VendorsModule from './modules/vendors';
import DiuModule from './modules/diu';
import OrderGroupsModule from './modules/orderGroups';

import WarehouseProductsModule from './modules/warehouseProducts/index';
import StorefrontProductGroupsModule from './modules/storefrontProductGroups/index';
import WarehouseProductGroupsModule from './modules/warehouseProductGroups/index';
import BrandFulfillmentBoxesModule from './modules/brandFulfillmentBoxes/index';
import FulfillmentBatchesModule from './modules/fulfillmentBatches/index';
import IntegrationCarriersModule from './modules/integrationCarriers/index';

import LedgerEntriesModule from './modules/ledgerEntries/index';
import SupportTicketsModule from './modules/supportTickets/index';

import DocsKnowledgebasePages from './modules/docs/knowledgebasePages/index';
import DocsKnowledgebaseGroups from './modules/docs/knowledgebaseGroups/index';
import DocsChangelog from './modules/docs/changelog/index';

import ApiAccessModule from './modules/apiAccess/index';
import OrderSourceIntegrationsModule from './modules/orderSourceIntegrations/index';
import ThirdPartyIntegrationsModule from './modules/thirdPartyIntegrations/index';

export default {
  g: GlobalModule,
  apiAccess: ApiAccessModule,
  account: AccountModule,
  userProfiles: UserProfilesModule,

  manageUsers: ManageUsersModule,
  userInvites: UserInvitesModule,

  ledgerEntries: LedgerEntriesModule,
  storefrontProducts: StorefrontProductsModule,
  irmsPurchaseOrders: IRMSPurchaseOrdersModule,
  irmsCustomerOrders: IRMSCustomerOrdersModule,

  vendors: VendorsModule,
  orderTags: OrderTagsModule,
  orders: OrdersModule,
  shipCodeMappings: ShipCodeMappings,
  productMappings: ProductMappingsModule,
  productMappingRequests: ProductMappingRequestsModule,
  clientShipCodeMappings: ClientShipCodeMappings,
  storefrontRateShops: BrandRateShops,
  logActions: LogActionsModule,
  projects: ProjectsModule,
  brands: BrandsModule,
  warehouses: WarehousesModule,

  warehouseShipments: WarehouseShipmentsModule,

  purchaseOrders: PurchaseOrdersModule,
  warehouseTransfers: WarehouseTransfersModule,
  manualShipments: ManualShipmentsModule,
  importSheetMappingMethods: ImportSheetMappingMethodsModule,
  warehouseProducts: WarehouseProductsModule,
  generatedReports: GeneratedReportsModule,

  rateCards: RateCardsModule,

  warehouseProductLocations: WarehouseProductLocationsModule,

  bulkShipments: BulkShipmentsModule,

  itemsReport: ItemsReportModule,
  returns: ReturnsModule,

  automation: Automation,
  contentTemplates: ContentTemplates,
  automationsContent: AutomationsContent,

  orderGroups: OrderGroupsModule,

  diu: DiuModule,

  storefrontProductGroups: StorefrontProductGroupsModule,
  warehouseProductGroups: WarehouseProductGroupsModule,
  brandFulfillmentBoxes: BrandFulfillmentBoxesModule,
  fulfillmentBatches: FulfillmentBatchesModule,
  integrationCarriers: IntegrationCarriersModule,
  storefrontShipments: StorefrontShipmentsModule,
  shipmentLabels: ShipmentLabelsModule,
  storefrontBulkActions: StorefrontBulkActionsModule,
  brandItems: BrandItemsModule,
  inventorySnapshots: InventorySnapshotsModule,
  'fulfillment/storefront-orders': StorefrontOrdersFulfillmentModule,
  'support-tickets': SupportTicketsModule,
  'billing/carrierBillingEntries': CarrierBillingEntriesModule,
  'billing/carrierInvoiceChargeConfigurations': CarrierInvoiceChargeConfigurationsModule,
  'billing/zoneLookupCardItems': ZoneLookupCardItemsModule,
  'billing/conversionRateHistoricalRecords': ConversionRateHistoricalRecordsModule,
  'billing/customerInvoices': BillingCustomerInvoicesModule,
  'billing/customerBillingLedger': BillingCustomerBillingLedgerModule,
  'billing/ptcFiles': BillingPtcFilesModule,
  'billing/carrierInvoices': BillingCarrierInvoicesModule,

  'manufacturing/workOrders': WorkOrdersModule,
  'manufacturing/billOfMaterials': BillOfMaterialsModule,
  'manufacturing/rndProjects': RnDProjectsModule,

  'docs/knowledgebasePages': DocsKnowledgebasePages,
  'docs/knowledgebaseGroups': DocsKnowledgebaseGroups,
  'docs/changelog': DocsChangelog,

  'tpl-adjustments': TPLAdjustmentsModule,
  'tpl-facilities': TPLFacilitiesModule,
  'tpl-customers': TPLCustomersModule,
  'tpl-shipmentServices': TPLShipmentServicesModule,
  'tpl-billingCodes': TPLBillingCodesModule,
  'tpl-uom': TPLUOMModule,
  'tpl-carriers': TPLCarriers,
  'tpl-receivers': TPLReceivers,

  orderSourceIntegrations: OrderSourceIntegrationsModule,
  thirdPartyIntegrations: ThirdPartyIntegrationsModule
};
